import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Injector,
  Input,
  OnInit,
} from '@angular/core';

import { FbTextboxWidget } from '../../../models';
import { WidgetBase } from '../../../models/widget-base';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TokenToDivPipe } from '../../../helpers/token-to-div.pipe';
import { ScribeSuggestionIndicatorComponent } from '../shared/scribe-suggestion-indicator/scribe-suggestion-indicator.component';
import { AmendmentFieldIndicatorComponent } from '../shared/amendment-field-indicator/amendment-field-indicator.component';

@Component({
  selector: 'app-fb-textbox',
  templateUrl: './fb-textbox.component.html',
  styleUrls: ['./fb-textbox.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    TokenToDivPipe,
    ScribeSuggestionIndicatorComponent,
    AmendmentFieldIndicatorComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FbTextboxComponent extends WidgetBase implements OnInit {
  @Input()
  public override set payload(value) {
    // if(value.properties instanceof Array) {
    //     this._payload = value;
    // } else {
    //     value.properties = [value.properties];
    //     this._payload = value;
    // }
    this._payload = value;
    this.ready.next(true);
  }
  public override get payload() {
    return this._payload;
  }

  constructor(private injector: Injector) {
    super(injector);
  }

  ngOnInit() {}

  override isValid() {
    return new FbTextboxWidget(this.payload).isValid();
  }
}
